import { IsString, IsNotEmpty, IsOptional } from 'class-validator';

export class NomenclatureTypeChildUpdateParameterRequest {
    @IsString()
    @IsNotEmpty()
    public fieldName: string;

    @IsOptional() // Could be null for calculated fields
    @IsString()
    @IsNotEmpty()
    public formula: string;

    constructor(data?: Partial<NomenclatureTypeChildUpdateParameterRequest>) {
        this.fieldName = data?.fieldName;
        this.formula = data?.formula;
    }
}
